import React from 'react';
import styles from './Cycle.module.scss';
import useApiData from '../../../../../../hooks/useApiData';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Loading from '../../../../Common/Loading/Loading';
import { getErrorComponentFromHttpError } from '../../../../Common/Error/Error';
import Button from '@mui/material/Button';
import APIClient from '../../../../../../util/APIClient';
import FormAlert from '../../../../Common/FormAlert/FormAlert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import useAuth from '../../../../../../hooks/useAuth';

export default function Cycle() {
  const navigate = useNavigate();
  const { groups } = useAuth();
  const [formAlert, setFormAlert] = React.useState(null);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const { cycleId } = useParams();
  const { data, error, isLoading } = useApiData({
    path: `/administrator/cycles/${cycleId}`,
  });

  async function setAsCurrent() {
    setIsUpdating(true);
    try {
      await APIClient.put(`/administrator/cycles/${cycleId}`, {
        isCurrent: true,
      });
      setFormAlert({
        severity: 'success',
        title: 'Cycle updated successfully!',
        message: 'Your cycle has been updated successfully. You will be redirected shortly.',
      });
      setTimeout(() => {
        navigate(`/administrator/organisation/cycles`);
      }, 3000);
    } catch {
      setFormAlert({
        severity: 'error',
        title: 'Could not update cycle!',
        message: 'Something went wrong during cycle update. Please contact the administrator for further support.',
      });
    } finally {
      setIsUpdating(false);
    }
  }

  if (isLoading) {
    return <Loading message="Fetching cycle..." />;
  }

  if (error || data === null) {
    return getErrorComponentFromHttpError(error);
  }

  return (
    <div className={styles.cycle}>
      {formAlert && <FormAlert alert={formAlert} />}
      <div className={styles.header}>
        <h1>{data.label}</h1>
        {groups.includes('administrators') && (
          <Button
            startIcon={<EditOutlinedIcon />}
            component={Link}
            to={`/administrator/organisation/cycles/${cycleId}/edit`}
            variant="outlined"
          >
            Edit
          </Button>
        )}
      </div>
      {groups.includes('administrators') && (
        <Button onClick={setAsCurrent} disabled={isUpdating || data.isCurrent} variant="contained">
          {`Set as current ${data.isCurrent ? '(already a current cycle)' : ''}`}
        </Button>
      )}
    </div>
  );
}
